module.exports = __webpack_public_path__ + "img/正方形2.3c5de720.jpg";